export default __webpack_public_path__ + "static/media/BartolomeoBold.9d38c42b.ttf";